export default __webpack_public_path__ + "static/media/check_circle.9844530c.svg";